(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  if (!customElements.get('sw-news-carousel')) {
    customElements.define('sw-news-carousel', class extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.current = 0;
        this.timer = null;
        this.interval = Math.max(4, Number(this.dataset.autoplaySeconds || 6)) * 1000;
        this.querySelector('[data-prev]')?.addEventListener('click', () => this.show(this.current - 1));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.current + 1));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.dot))));
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        this.start();
      }

      disconnectedCallback() {
        this.stop();
      }

      show(index) {
        if (this.slides.length < 2) return;
        this.current = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === this.current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        this.dots.forEach((dot, dotIndex) => {
          const active = dotIndex === this.current;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
        this.start();
      }

      start() {
        this.stop();
        if (this.slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.timer = window.setInterval(() => this.show(this.current + 1), this.interval);
      }

      stop() {
        if (this.timer) window.clearInterval(this.timer);
        this.timer = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-agency-service-orbit"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = "[data-agency-service-scroll]";
    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

    const initialize = (section) => {
      if (!section || section.dataset.scrollReady === "true") return;

      const shell = section.querySelector("[data-scroll-shell]");
      const visual = section.querySelector("[data-scroll-visual]");
      const cards = Array.from(section.querySelectorAll("[data-scroll-card]"));
      const steps = Array.from(section.querySelectorAll("[data-scroll-step]"));
      const current = section.querySelector("[data-current-index]");
      const links = cards.map((card) => card.querySelector("a"));
      const cardRail = section.querySelector(".agency-service-scroll__cards");
      const previousButton = section.querySelector("[data-mobile-prev]");
      const nextButton = section.querySelector("[data-mobile-next]");
      const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      const mobileQuery = window.matchMedia("(max-width: 749px)");

      if (!shell || !visual || !cardRail || cards.length === 0) return;

      section.dataset.scrollReady = "true";

      if (reducedMotion) {
        section.classList.add("is-reduced");
        cards.forEach((card) => {
          card.setAttribute("aria-hidden", "false");
          const link = card.querySelector("a");
          if (link) link.tabIndex = 0;
        });
        return;
      }

      let active = -1;
      let desktopTicking = false;
      let mobileTicking = false;

      const setProgress = (progress) => {
        section.style.setProperty("--scroll-progress", clamp(progress, 0, 1).toFixed(4));
      };

      const setActive = (next, mobileMode) => {
        const safeIndex = clamp(next, 0, cards.length - 1);
        active = safeIndex;

        cards.forEach((card, index) => {
          const selected = index === active;
          card.classList.toggle("is-active", selected);
          card.setAttribute("aria-hidden", mobileMode || selected ? "false" : "true");
          if (links[index]) links[index].tabIndex = mobileMode || selected ? 0 : -1;
        });

        steps.forEach((step, index) => {
          step.classList.toggle("is-active", index === active);
        });

        if (current) current.textContent = String(active + 1).padStart(2, "0");
        if (previousButton) previousButton.disabled = active === 0;
        if (nextButton) nextButton.disabled = active === cards.length - 1;
      };

      const renderDesktop = () => {
        desktopTicking = false;
        if (mobileQuery.matches) return;

        const rect = shell.getBoundingClientRect();
        const range = Math.max(shell.offsetHeight - window.innerHeight, 1);
        const progress = clamp(-rect.top / range, 0, 1);
        const position = progress * Math.max(cards.length - 1, 0);
        const nextActive = clamp(Math.round(position), 0, cards.length - 1);

        setProgress(progress);

        cards.forEach((card, index) => {
          const delta = index - position;
          const distance = Math.min(Math.abs(delta), 2.4);
          const y = delta < 0 ? delta * 28 : delta * 12;
          const scale = 1 - distance * 0.045;
          const opacity = clamp(1 - distance * 0.78, 0, 1);
          const blur = distance * 7;
          const rotate = delta * -1.35;

          card.style.setProperty("--card-y", `${y}%`);
          card.style.setProperty("--card-scale", scale.toFixed(4));
          card.style.setProperty("--card-opacity", opacity.toFixed(4));
          card.style.setProperty("--card-blur", `${blur.toFixed(2)}px`);
          card.style.setProperty("--card-rotate", `${rotate.toFixed(2)}deg`);
          card.style.zIndex = String(100 - Math.round(distance * 10) - index);
        });

        setActive(nextActive, false);
      };

      const requestDesktopRender = () => {
        if (desktopTicking || mobileQuery.matches) return;
        desktopTicking = true;
        window.requestAnimationFrame(renderDesktop);
      };

      const syncMobile = () => {
        mobileTicking = false;
        if (!mobileQuery.matches) return;

        const center = cardRail.scrollLeft + cardRail.clientWidth / 2;
        let nearestIndex = 0;
        let nearestDistance = Number.POSITIVE_INFINITY;

        cards.forEach((card, index) => {
          const cardCenter = card.offsetLeft + card.offsetWidth / 2;
          const distance = Math.abs(cardCenter - center);
          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestIndex = index;
          }
        });

        setActive(nearestIndex, true);
        setProgress((nearestIndex + 1) / cards.length);
      };

      const requestMobileSync = () => {
        if (mobileTicking || !mobileQuery.matches) return;
        mobileTicking = true;
        window.requestAnimationFrame(syncMobile);
      };

      const goToMobileCard = (index) => {
        const targetIndex = clamp(index, 0, cards.length - 1);
        const card = cards[targetIndex];
        const left = card.offsetLeft - (cardRail.clientWidth - card.offsetWidth) / 2;
        cardRail.scrollTo({ left, behavior: "smooth" });
      };

      const setMode = () => {
        if (mobileQuery.matches) {
          section.classList.add("is-mobile");
          cards.forEach((card) => {
            card.style.removeProperty("--card-y");
            card.style.removeProperty("--card-scale");
            card.style.removeProperty("--card-opacity");
            card.style.removeProperty("--card-blur");
            card.style.removeProperty("--card-rotate");
            card.style.removeProperty("z-index");
          });
          setActive(Math.max(active, 0), true);
          requestMobileSync();
        } else {
          section.classList.remove("is-mobile");
          renderDesktop();
        }
      };

      window.addEventListener("scroll", requestDesktopRender, { passive: true });
      window.addEventListener("resize", () => {
        requestDesktopRender();
        requestMobileSync();
      }, { passive: true });
      cardRail.addEventListener("scroll", requestMobileSync, { passive: true });
      mobileQuery.addEventListener("change", setMode);

      if (previousButton) {
        previousButton.addEventListener("click", () => goToMobileCard(active - 1));
      }

      if (nextButton) {
        nextButton.addEventListener("click", () => goToMobileCard(active + 1));
      }

      document.addEventListener("shopify:block:select", (event) => {
        const selectedCard = event.target.closest("[data-scroll-card]");
        if (!selectedCard || !section.contains(selectedCard)) return;
        const index = Number(selectedCard.dataset.index || 0);

        if (mobileQuery.matches) {
          goToMobileCard(index);
          return;
        }

        const range = Math.max(shell.offsetHeight - window.innerHeight, 1);
        const target = shell.getBoundingClientRect().top + window.scrollY + (index / Math.max(cards.length - 1, 1)) * range;
        window.scrollTo({ top: target, behavior: "smooth" });
      });

      setMode();
    };

    const initializeAll = (root = document) => {
      if (root.matches && root.matches(selector)) initialize(root);
      root.querySelectorAll(selector).forEach(initialize);
    };

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => initializeAll(), { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener("shopify:section:load", (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
